import SectionHeading from "@/components/SectionHeading";
import { Reveal, GoldLine } from "@/components/Reveal";
import { waLink, WA_MESSAGES } from "@/config/site";
import { Gem, ShieldCheck, HeartHandshake, Sparkles, Users } from "lucide-react";
import { DIFFERENCE } from "@/config/site";

const STEPS = [
    { n: "01", title: "Discover", copy: "Share your idea, inspiration or occasion." },
    { n: "02", title: "Design", copy: "Refine the concept and details with our experts." },
    { n: "03", title: "Create", copy: "Bring the final vision to life." },
];

const ICONS = { Gem, ShieldCheck, HeartHandshake, Sparkles, Users };

export const CustomJewellery = () => (
    <section className="py-24 sm:py-36" data-testid="custom-jewellery">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="Bespoke"
                title={<>Your Vision. <span className="italic gold-text">Our Craftsmanship.</span></>}
                copy="Have something special in mind? Discuss your vision with our jewellery experts and explore the possibilities of a piece created around you."
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 max-w-5xl mx-auto">
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.12}>
                        <div className="relative text-center md:text-left" data-testid={`custom-step-${s.n}`}>
                            <span className="font-serif italic text-6xl sm:text-7xl text-gold/15 select-none" aria-hidden="true">{s.n}</span>
                            <h3 className="font-serif text-2xl text-ivory mt-2 tracking-wide uppercase">{s.title}</h3>
                            <GoldLine delay={0.2 + i * 0.12} className="w-12 my-4 mx-auto md:mx-0" />
                            <p className="text-sm text-sand leading-relaxed">{s.copy}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.35} className="text-center mt-14">
                <a
                    href={waLink(WA_MESSAGES.custom)}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="custom-enquiry-btn"
                    className="inline-block bg-gold text-obsidian text-[11px] tracking-[0.25em] uppercase px-10 py-4 hover:bg-gold-bright transition-colors"
                >
                    Start a Custom Jewellery Enquiry
                </a>
            </Reveal>
        </div>
    </section>
);

export const Difference = () => (
    <section className="py-24 sm:py-36 bg-espresso/60 border-y border-gold/10" data-testid="bsk-difference">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="Why BSK Jewellers"
                title={<>The BSK <span className="italic gold-text">Difference</span></>}
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-gold/10 border border-gold/10">
                {DIFFERENCE.map((d, i) => {
                    const Icon = ICONS[d.icon];
                    return (
                        <Reveal key={d.title} delay={i * 0.08}>
                            <div className="bg-obsidian p-8 h-full flex flex-col gap-4 hover:bg-charcoal transition-colors duration-500" data-testid={`difference-${d.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                <Icon size={22} strokeWidth={1.25} className="text-gold" />
                                <h3 className="font-serif text-xl text-ivory">{d.title}</h3>
                                <p className="text-[13px] text-sand leading-relaxed">{d.note}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
